import React from 'react';
const Svg = (props) => (React.createElement("svg", Object.assign({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { opacity: "0.3" },
        React.createElement("circle", { cx: "20", cy: "20", r: "20", fill: "black" })),
    React.createElement("path", { d: "M16 13V27L27 20L16 13Z", fill: "white" })));
export default Svg;
//# sourceMappingURL=Play.js.map